import { Button, Grid, Box, IconButton, Stack, Typography, TextField as MuiTextField, Checkbox } from '@mui/material';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch } from '../../../../../utils';


const TABLE_HEADER = [
    {
        header: 'Product Name',
        accessor: (row) =>
            row?.productDetails?.map(detail => detail.product?.main?.name).join(', ') || 'N/A'
    }
];
export const MedicineEditForm = ({ onClose, chargeType = 'opd_charges', doctorID, onAdd,stockProduct,filteredServiceList,setFilteredServiceList }) => {


    const [input, setInput] = useState('');

    const mergeDropdowns = useCallback(() => {
        const mergedData = [
            ...stockProduct.map(item => ({
                ...item,
                type: item.type || 'service',
                name: item.main?.name
            })),
        ];
        return mergedData;
    }, [stockProduct]);


useEffect(()=>{
    console.log("HELLLO STCOKS",stockProduct)
},[stockProduct])





    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                product: Yup.string().required('Please Enter Product'),
                batch_no: Yup.string().required('Please Enter Batch No'),
                exp_date: Yup.string().required('Please Enter Exp Date'),
                sal_rate: Yup.string().required('Please Enter Sale Date'),
            })
        ),
        defaultValues: {
            po_qty: 0,
            bill_qty: 0,
            free_qty: 0,
            loose_qty: 0,
            rec_qty: 0,
            quantity: 1,
            rate: 0,
            amount: 0,
            net_amt: 0,
            gst_amt: 0,
            disc_amt: 0,
            disc_per: 0,
            gst_per: 0,
            sgst: 0,
            cgst: 0,
        },
        mode: 'all'
    });
    const { reset } = methods

    const { handleSubmit, setValue, watch } = methods;

    const formSubmitHandler = (formValues) => {
        formValues.gst_per = +formValues.gst_per;
        formValues.disc_per = +formValues.disc_per;
        formValues.quantity = +formValues.quantity;
        const medicineId = stockProduct
        .flatMap(item => item.productDetails) 
        .find(detail => detail.product.main?.name === formValues.product) 
        ?.product._id || '';  
    const transformedValues = {
        ...formValues,
        product: medicineId 
    };
    console.log("HELLO TRANSFORMED VALUES", transformedValues);
    onAdd(transformedValues);
    };

    const handleServiceSelection = (row) => {
        console.log("HELLLO SERVICE SELECTION", row)
        const isProduct = stockProduct.some(product => product._id === row._id);

        if (isProduct) {
            setValue('rate', row[chargeType] || 0);
        }

        methods.resetField('product');
        setValue('product', row?.productDetails[0]?.product?.main?.name);
        setValue('rate', row?.productDetails[0]?.rate);
        setValue('batch_no', row?.productDetails[0]?.batch_no);
        setValue('gst', row?.productDetails[0]?.gst);
        const expDate = row?.productDetails[0]?.exp_date;
        if (expDate) {
            const formattedDate = new Date(expDate);
            const year = formattedDate.getFullYear();
            const month = (formattedDate.getMonth() + 1).toString().padStart(2, '0');
            const formattedExpDate = `${year}-${month}`;

            setValue('exp_date', formattedExpDate);
        }
        setValue('conversion', row?.main?.conversion);
    };


    const billQty = watch('bill_qty');
    const rate = watch('rate');
    const freeQty = watch('free_qty');
    const discPerWatch = watch('dis_percent');
    const discAmtWatch = watch('dis_amt');
    const gstPerWatch = watch('gst');
    const mrp = watch('mrp');

    useEffect(() => {
        const amount = billQty * rate;
        const RecQty = Number(freeQty) + Number(billQty);
        const discAmt = parseFloat(((amount * discPerWatch) / 100).toFixed(2));
        const taxable = parseFloat((amount - discAmt).toFixed(2));
        const gstAmt = parseFloat((((amount - discAmt) * gstPerWatch) / 100).toFixed(2));
        const netAmt = parseFloat((Number(taxable) + Number(gstAmt)).toFixed(2));
        const sgst = gstAmt / 2;
        setValue('amount', parseFloat(amount.toFixed(2)));
        setValue('dis_amt', discAmt || 0);
        setValue('gst_amt', gstAmt || 0);
        setValue('taxable', taxable || 0);
        setValue('rec_qty', RecQty || 0);
        setValue('sal_rate', mrp || 0);
        setValue('net_amt', netAmt || 0);
        setValue('sgst', sgst || 0);
        setValue('cgst', sgst || 0);
    }, [billQty, rate, discPerWatch, gstPerWatch, freeQty, setValue]);

    useEffect(() => {
        if (billQty && rate && discAmtWatch !== undefined) {
            const amount = billQty * rate;
            const newDiscPer = parseFloat(((discAmtWatch / amount) * 100).toFixed(2));
            setValue('dis_percent', newDiscPer);
        }
    }, [billQty, rate, discAmtWatch, setValue]);




    useEffect(() => {
        if (mrp !== undefined) {
            setValue('sal_rate', mrp);
        }
    }, [mrp, setValue]);

    // useEffect(() => {
    //     const filtered = mergeDropdowns().filter((item) =>
    //         item.productDetails &&
    //         item.productDetails.some(
    //             (detail) =>
    //                 detail.product &&
    //                 detail.product.toLowerCase().includes(input.toLowerCase())
    //         )
    //     );
    //     setFilteredServiceList(filtered);
    // }, [input, mergeDropdowns]);

    const handleInputChange = (e) => {
        setInput(e.target.value);
    };

    return (
        <Stack spacing={1} sx={{ height: '100%' }}>
            <Stack
                padding={1.5}
                direction="row"
                spacing={2}
                alignItems="center"
                justifyContent="space-between"
                borderBottom="1px solid"
                borderColor="grey.300"
            >
                <Typography variant="h4" fontWeight="bold">
                    Add Details
                </Typography>
                <IconButton onClick={onClose}>
                    <CloseIcon color="error" fontSize="large" />
                </IconButton>
            </Stack>
            <FormProvider
                sx={{ height: '100%', overflow: 'auto' }}
                methods={methods}
                onSubmit={handleSubmit(formSubmitHandler)}
            >
                <Grid container spacing={1} sx={{ flex: 1, height: '100%', overflow: 'auto' }}>
                    <Grid
                        item
                        xs={4}
                        sx={{
                            height: '100%',
                            overflow: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 1
                        }}
                    >
                        <Typography variant="h6" >
                            No. Of Product :- {stockProduct.length}
                        </Typography>
                        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 2 }}>
                            <MuiTextField
                                sx={{
                                    width: '100%',
                                    '& .MuiOutlinedInput-root': {
                                        padding: '0',
                                    },
                                    '& .MuiOutlinedInput-input': {
                                        padding: '8px 14px',
                                    },
                                }}
                                label="Search Product"
                                variant="outlined"
                                value={input}
                                onChange={handleInputChange}
                                InputProps={{
                                    style: {
                                        fontSize: '12px',
                                        fontWeight: 600
                                    },
                                }}
                            />
                        </Stack>
                        <Table
                            containerSX={{ flex: 1, height: '100%', overflow: 'auto', }}
                            size="small"
                            sx={{ fontSize: "32px" }}
                            data={filteredServiceList.length > 0 ? filteredServiceList : mergeDropdowns()}
                            columns={TABLE_HEADER}
                            onRowClick={handleServiceSelection}
                        />
                    </Grid>
                    <Grid item xs={8}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, px: 2 }}>
                            <Stack spacing={1} direction="row" alignItems="center">
                                <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Product</Typography>
                                <TextField
                                    sx={{ flex: 0.8 }}
                                    name="product"
                                    placeholder="Select Product"
                                    disabled
                                />
                            </Stack>
                            <Stack spacing={1} direction="row" alignItems="center">
                                <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Bill Qty</Typography>
                                <TextField sx={{ flex: 0.8 }} name="bill_qty" />
                            </Stack>
                            <Stack spacing={1} direction="row" alignItems="center">
                                <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Rate</Typography>
                                <TextField sx={{ flex: 0.8 }} name="rate" />
                            </Stack>
                            <Stack spacing={1} direction="row" alignItems="center">
                                <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Amount</Typography>
                                <TextField sx={{ flex: 0.8 }} disabled name="amount" />
                            </Stack>
                            <Stack spacing={1} direction="row" alignItems="center">
                                <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Batch No</Typography>
                                <TextField sx={{ flex: 0.8 }} name="batch_no" />
                            </Stack>
                            <Stack spacing={1} direction="row" alignItems="center">
                                <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Exp. Date</Typography>
                                <TextField sx={{ flex: 0.8 }} name="exp_date" type="month" />
                            </Stack>
                            <Stack spacing={1} direction="row" alignItems="center">
                                <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>GST%</Typography>
                                <TextField sx={{ flex: 0.8 }} disabled name="gst" />
                            </Stack>
                            <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end">
                                <Button variant="contained" type="submit"   >
                                    Add
                                </Button>
                                <Button variant="outlined" onClick={onClose} color="error">
                                    Close
                                </Button>
                            </Stack>
                        </Box>

                    </Grid>
                </Grid>
            </FormProvider>
        </Stack>
    );
};
